import React from 'react';
import ApexCharts from 'react-apexcharts';
import SpinnerLoader from '../../../../V2/Common/LoadingAnimation/SpinnerLoader.component';

// Chart-only component now. Stats and section heading live in Home.index.jsx
// where they belong with the rest of the dashboard layout.
export default function UploadsCountChart({ chartOptions, chartSeries, loading }) {
  return (
    <SpinnerLoader loading={loading}>
      <ApexCharts options={chartOptions} series={chartSeries} type='area' height={240} />
    </SpinnerLoader>
  );
}
